$(window).on("scroll resize", function (e) {
    const amount = $(this).scrollTop()
    if (amount > 0) {
    $("body").addClass("minimize-header")
    } else {
    $("body").removeClass("minimize-header")
    }
})
.trigger("scroll")
